import { Form, LEAD_COLLECTOR_STEPS } from '@entities/leadCollector';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import { formatDate } from '@shared/libs/format-date';
import { RadioButton } from '@shared/ui/kit';
import { EyeIcon } from '@shared/assets/icons';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface FormListItemProps {
  form: Form;
  chosenForm: Form | null;
  chooseForm: (form: Form) => void;
  onPreviewTemplate: (formId: number) => void;
  setPrevStep: (step: number) => void;
  selectedForm?: Form | null;
}

export const FormListItem = ({
  form,
  chosenForm,
  chooseForm,
  onPreviewTemplate,
  setPrevStep,
  selectedForm,
}: FormListItemProps) => {
  const { id, name, createdAt } = form;
  const isFormChosen = chosenForm ? chosenForm?.id === id : selectedForm?.id === id;

  const handleViewForm = () => {
    setPrevStep(LEAD_COLLECTOR_STEPS.CHOOSE_FORM);
    onPreviewTemplate(form.id);
  };

  return (
    <div {...stylex.props(styles.container)}>
      <div {...stylex.props(styles.form)}>
        <div {...stylex.props(styles.description)}>
          <span {...stylex.props(styles.name, isFormChosen && styles.nameChosen)}>{name}</span>
          <span {...stylex.props(styles.date)}>{formatDate(createdAt)}</span>
        </div>

        <RadioButton
          settings={{ background: 'transparent' }}
          changeFunction={() => chooseForm(form)}
          isChecked={isFormChosen}
        />
      </div>

      <UnstyledButton onClick={handleViewForm}>
        <span {...stylex.props(styles.watch)}>
          <EyeIcon /> Посмотреть
        </span>
      </UnstyledButton>
    </div>
  );
};
